import {IDialogConfirmationHandler} from "../../../../../services/dialog/dialog.service.interface";
import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../../hooks/use-services.hook";
import {StandardDialogPageComponent} from "../../../../../components/modal/page/standard-dialog-page.component";
import {StandardDialogHeaderComponent} from "../../../../../components/modal/header/standard-dialog-header.component";
import {
    StandardDialogContentComponent
} from "../../../../../components/modal/content/standard-dialog-content.component";
import {StandardDialogFooterComponent} from "../../../../../components/modal/footer/standard-dialog-footer.component";
import {SaveButtonBox} from "../../../../../components/forms/buttons/save-button.box";
import {AgencyChangePasswordEditorComponent} from "./agency-change-password-editor.component";
import {
    IChangePasswordFormViewModel
} from "../../../../../services/user/models/change-password/change-password-form-view-model.interface";
import {ILoginResponse} from "../../../../../services/airline-webapi/responses/login.response";


interface ChangePasswordEditorDialogComponentProps {
    dialogHandler: IDialogConfirmationHandler<ILoginResponse>;
    changePasswordEditor: IChangePasswordFormViewModel;
}

export const AgencyChangePasswordEditorDialogComponent: React.FC<ChangePasswordEditorDialogComponentProps> = observer((props) => {
    const services = useServices();

    const onChangePassword = async () => {
        const changePasswordResponse = await props.changePasswordEditor.executeChangePassword();
        if(changePasswordResponse) {
            props.dialogHandler.accept(changePasswordResponse);
        }
    }

    return (
        <StandardDialogPageComponent>
            <StandardDialogHeaderComponent title={services.language.translate('Change user password')}
                                           dialogHandler={props.dialogHandler}>

            </StandardDialogHeaderComponent>
            <StandardDialogContentComponent dialogHandler={props.dialogHandler}>
                <AgencyChangePasswordEditorComponent changePasswordEditor={props.changePasswordEditor} />
            </StandardDialogContentComponent>
            <StandardDialogFooterComponent dialogHandler={props.dialogHandler}>
                <SaveButtonBox onClick={onChangePassword}>
                    {services.language.translate('Change password')}
                </SaveButtonBox>
            </StandardDialogFooterComponent>
        </StandardDialogPageComponent>
    );
})